const BatteryType_Icon = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="26" height="26" rx="13" fill="#F2F8F6" />
      <path
        d="M19.1875 10.1875H18.625V9.625C18.625 9.32663 18.5065 9.04048 18.2955 8.82951C18.0845 8.61853 17.7984 8.5 17.5 8.5H15.25V9.625H17.5V11.3125H19.1875V14.6875H17.5V16.375H14.6875V17.5H17.5C17.7984 17.5 18.0845 17.3815 18.2955 17.1705C18.5065 16.9595 18.625 16.6734 18.625 16.375V15.8125H19.1875C19.4859 15.8125 19.772 15.694 19.983 15.483C20.194 15.272 20.3125 14.9859 20.3125 14.6875V11.3125C20.3125 11.0141 20.194 10.728 19.983 10.517C19.772 10.306 19.4859 10.1875 19.1875 10.1875ZM10.1875 16.375H7.375V9.625H10.75V8.5H7.375C7.07663 8.5 6.79048 8.61853 6.5795 8.82951C6.36853 9.04048 6.25 9.32663 6.25 9.625V16.375C6.25 16.6734 6.36853 16.9595 6.5795 17.1705C6.79048 17.3815 7.07663 17.5 7.375 17.5H10.1875V16.375Z"
        fill="#79C8B0"
      />
      <path
        d="M19.1875 10.1875H18.625V9.625C18.625 9.32663 18.5065 9.04048 18.2955 8.82951C18.0845 8.61853 17.7984 8.5 17.5 8.5H15.25V9.625H17.5V11.3125H19.1875V14.6875H17.5V16.375H14.6875V17.5H17.5C17.7984 17.5 18.0845 17.3815 18.2955 17.1705C18.5065 16.9595 18.625 16.6734 18.625 16.375V15.8125H19.1875C19.4859 15.8125 19.772 15.694 19.983 15.483C20.194 15.272 20.3125 14.9859 20.3125 14.6875V11.3125C20.3125 11.0141 20.194 10.728 19.983 10.517C19.772 10.306 19.4859 10.1875 19.1875 10.1875ZM10.1875 16.375H7.375V9.625H10.75V8.5H7.375C7.07663 8.5 6.79048 8.61853 6.5795 8.82951C6.36853 9.04048 6.25 9.32663 6.25 9.625V16.375C6.25 16.6734 6.36853 16.9595 6.5795 17.1705C6.79048 17.3815 7.07663 17.5 7.375 17.5H10.1875V16.375Z"
        fill="url(#paint0_linear_1930_3097)"
      />
      <path
        d="M12.3305 17.2637L11.4193 16.6112L13.5961 13.5625H9.27051L13.1236 8.71375L14.0011 9.41124L11.5993 12.4375H15.7786L12.3305 17.2637Z"
        fill="#79C8B0"
      />
      <path
        d="M12.3305 17.2637L11.4193 16.6112L13.5961 13.5625H9.27051L13.1236 8.71375L14.0011 9.41124L11.5993 12.4375H15.7786L12.3305 17.2637Z"
        fill="url(#paint1_linear_1930_3097)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1930_3097"
          x1="17.6758"
          y1="16"
          x2="12.821"
          y2="8.81077"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#1FA37C" />
          <stop offset="1" stop-color="#1FA37C" stop-opacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1930_3097"
          x1="10.1854"
          y1="17.2637"
          x2="10.1854"
          y2="8.71375"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#1FA37C" />
          <stop offset="1" stop-color="#1FA37C" stop-opacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default BatteryType_Icon;
